export function convertStringToArray(value) {
    return value.split(',');
}
